module.exports = __webpack_public_path__ + "img/ycg_login.2881143f.svg";